import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import {
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  Menu,
  Typography
} from '@mui/material';
import React from 'react';
import { HeadCell } from '../../../models/headCell';

interface Props {
  columns: HeadCell[];
  onColumnClick: (
    column: HeadCell
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ViewTableColumns = (props: Props): JSX.Element => {
  const [columnMenuEl, setColumnMenuEl] = React.useState<null | HTMLElement>(
    null
  );
  const openColumnMenuEl = Boolean(columnMenuEl);

  const handleCloseColumnMenu = () => {
    setColumnMenuEl(null);
  };

  const handleClickColumnMenu = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setColumnMenuEl(event.currentTarget);
  };

  return (
    <>
      <IconButton onClick={handleClickColumnMenu}>
        <ViewColumnIcon />
      </IconButton>

      <Menu
        anchorEl={columnMenuEl}
        open={openColumnMenuEl}
        onClose={handleCloseColumnMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <Typography sx={{ p: 1 }}>Show Columns</Typography>
        <Divider />
        <FormGroup sx={{ pl: '15px' }}>
          {props.columns.map((column) => (
            <FormControlLabel
              key={column.id}
              control={
                <Checkbox
                  checked={column.visible}
                  onChange={props.onColumnClick(column)}
                />
              }
              label={column.label}
            />
          ))}
        </FormGroup>
      </Menu>
    </>
  );
};

export default ViewTableColumns;
